import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { RadioButtonField, PhoneInputField, TextInputField } from 'common/components/form_fields';
import AnimatedButton from 'common/components/animated_button';

/**
 * Mobile phone validation methods.
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */

export default class ValidationMethods extends Component {
  constructor(props) {
    super(props);

    this.state = { codeResendEnabled: false };

    this.enableCodeResend = this.enableCodeResend.bind(this);
    this.disableCodeResend = this.disableCodeResend.bind(this);
    this.sendCode = this.sendCode.bind(this);
  }

  enableCodeResend() {
    this.setState({ codeResendEnabled: true });
  }

  disableCodeResend() {
    this.setState({ codeResendEnabled: false });
  }

  sendCode() {
    this.props.updatePhone();
    this.disableCodeResend();
  }

  render() {
    const {
      method, phone, code, user, onChangeMethod, onChangePhone, onChangeCode,
      onBlurPhone, phoneError
    } = this.props;

    return (
      <div className="verification-methods">
        <RadioButtonField meta={{}} value="smartphone"
          label={
            <span>
              Verify using my smartphone
              <span className="details"> (has a camera + internet access) </span>
            </span>
          }
          input={{
            name: "method",
            value: method,
            onChange: onChangeMethod
          }}/>

        <div className={"how-it-works" + (method != "smartphone"? " hide":"")}>
          <h5>How it Works</h5>
          <ol>
            <li>Enter your mobile number below.</li>
            <li>We send a link via SMS to your smartphone.</li>
            <li>Open the link and take two photos with your phone.</li>
            <li>Done!</li>
          </ol>
          <PhoneInputField
            meta={{touched: !!phoneError || !!phone, invalid: !!phoneError, error: phoneError}}
            label="Mobile phone"
            input={{
              value: phone,
              name: "phone_smart",
              onChange: (e) => onChangePhone(e.target.value),
              onBlur: onBlurPhone
            }}/>
        </div>

        <RadioButtonField meta={{}} value="non-smartphone"
          label={
            <span>
              Verify using my computer
              <span className="details"> (has a webcam) </span>
            </span>
          }
          input={{
            name: "method",
            value: method,
            onChange: onChangeMethod
          }}/>

        <div className={"how-it-works" + (method != "non-smartphone"? " hide":"")}>
          <h5>How it Works</h5>
          <ol>
            <li>Enter your mobile number below.</li>
            <li>We send a code via SMS to your mobile phone.</li>
            <li>Enter the code below and use your computer webcam to verify your ID.</li>
            <li>Done!</li>
          </ol>

          {this.state.codeResendEnabled || !user.mobileUpdated ?
          <div>
            <PhoneInputField
              meta={{touched: !!phoneError || !!phone, invalid: !!phoneError, error: phoneError}}
              label="Mobile phone"
              input={{
                value: phone,
                name: "phone_non_smart",
                onChange: (e) => onChangePhone(e.target.value)
              }}
            />
            <AnimatedButton processing={user.updatingMobile} baseBtnClass="btn-secondary"
              label="Send code" processingLabel="Sending code..."
              errorMsg={user.error} successMsg="Done!" onClick={this.sendCode}
              disabled={!!phoneError || !phone}/>
            </div>: ''}

          {user.mobileUpdated ?
            <div>
              <TextInputField meta={{}} label="Verification code"
              input={{
                value: code,
                name: "code",
                onChange: (e) => onChangeCode(e.target.value)
              }}/>
              <button className="btn btn-sm btn-text" onClick={this.enableCodeResend}>
                Resend code
              </button>
            </div>:''
          }
        </div>

        <RadioButtonField meta={{}} value="none" label="I don't have a mobile phone or webcam"
          input={{
            name: "method",
            value: method,
            onChange: onChangeMethod
          }}/>

        <div className={"how-it-works" + (method != "none"? " hide":"")}>
          <p>
            You will need to have a smartphone or basic mobile phone + computer
            webcam to complete your verification process. If you don't have either,
            <Link to="/help/contact/" target="_blank"> contact your support team</Link>.
          </p>
        </div>

      </div>)
  }
}



// WEBPACK FOOTER //
// ./registration/creative/components/phone_validation_methods.jsx